import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { evaluationStatusColumns } from "./EvaluationStatus.columns";
import { evaluationStatusRows } from "./EvaluationStatus.data";

const EvaluationStatusTable = () => {
  return (
    <DefaultDataGrid
      loading={false}
      rows={evaluationStatusRows}
      columns={evaluationStatusColumns}
      getRowHeight={() => "auto"}
      disableRowSelectionOnClick
      hideFooter
      sx={{
        "& .MuiDataGrid-cell": {
          alignItems: "flex-start",
          py: 1,
        },
      }}
    />
  );
};

export default EvaluationStatusTable;
